import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { SelecionaEntidadeVO } from '..';
import { Pageable, McticHttpParams, Page, McticHttpClient } from '@mctic/ng-core';

@Injectable({
  providedIn: 'root'
})
export class SelecionaEntidadeService {

  private readonly service = '/sepin-backend/rest/seleciona-entidade';

  constructor(private readonly http: McticHttpClient) {
  }

  consultar(idUnicoPessoaFisica: number, anoBase: number,
    pageable: Pageable): Observable<Page<SelecionaEntidadeVO>> {
    const queryParams = new McticHttpParams()
      .setNumber('idUnicoPessoaFisica', idUnicoPessoaFisica)
      .setNumber('anoBase', anoBase)
      .setPageable(pageable);

    return this.http.get<Page<SelecionaEntidadeVO>>(
      `${this.service}/query`, { params: queryParams.toHttpParams() }
    );
  }

  obterEntidadesUsuarioPorId(idUsuario: number): Observable<SelecionaEntidadeVO[]> {
    return this.http.get<SelecionaEntidadeVO[]>(`${this.service}/${idUsuario}`);
  }
}
